import SingleReferenceRecord from "../../../Records/References/ReferencesComponents/SingleReferenceRecord";
import { ImageFieldPresentation } from "../../../Records/RecordNameCell";
import { ReferenceValue } from "../../../../types/TenantInterfaces";
import { Person } from "../../../../types/GlobalInterfaces";
import IconButton from "../../../../elements/IconButton";

function Member({
  member,
  imageField,
  imageFieldPresentation,
  metadataField,
  metadataFieldType,
  isOwner,
  user,
  handleDeleteMember,
}: {
  member: ReferenceValue;
  imageField: string | null;
  imageFieldPresentation: ImageFieldPresentation;
  metadataField: string | null;
  metadataFieldType: string | null;
  isOwner: boolean;
  user: Person;
  handleDeleteMember: (memberID: string) => void;
}) {
  return (
    <div key={member.id} className="tw:flex tw:justify-between tw:pt-2">
      <SingleReferenceRecord
        existingValue={member}
        submitting={false}
        imageField={imageField || ""}
        imageFieldPresentation={imageFieldPresentation}
        metadataField={metadataField}
        metadataFieldType={metadataFieldType}
        tableView={false}
        disableViewRecord={false}
        // @ts-ignore
        onOpen={null}
        // @ts-ignore
        onView={null}
      />
      {isOwner && user.id !== member.id && (
        <IconButton
          icon="mdi mdi-close"
          onClick={() => handleDeleteMember(member.id)}
          color="danger"
          size="sm"
          outline={true}
        />
      )}
    </div>
  );
}

export default Member;
